import { TextWidth } from '@ta-interaktiv/react-disco-grid'
import { TextBuilder, tb_form } from 'classes/TextBuilder'
import GenderBarChart from 'components/GenderBarChart'
import GenderSVGColumnChart from 'components/GenderSVGColumnChart'
import { Loader } from 'components/Loader'
import { firebaseContext } from 'components/MainComponent/FirebaseContext'
import { getQuestionData } from 'components/MainComponent/QuestionData'
import { ResetButton } from 'components/Utils/localstorage'
import { _t } from 'components/Utils/translation'
import { get, onValue, ref } from 'firebase/database'
import { useContext, useEffect, useRef, useState } from 'react'
import { scrollIntoView } from 'scrollIntoView'
import styled from 'styled-components'
import { useWindowSize } from 'usehooks-ts'

function userInGroup(
  user: Answers,
  genderCompare: string,
  ageCompare: string,
  orientationCompare: string,
  relationCompare: string
) {
  if (genderCompare !== 'all' && genderCompare !== user.gender) {
    return false
  }
  if (ageCompare !== 'all' && ageCompare !== user.age) {
    return false
  }
  if (
    orientationCompare !== 'all' &&
    orientationCompare !== user.sexual_orientation
  ) {
    return false
  }
  if (
    relationCompare !== 'all' &&
    relationCompare !== user.relationship_status
  ) {
    return false
  }

  return true
}

const Evaluation = ({
  lang,
  answers,
  colorMode,
}: {
  lang: 'de' | 'fr'
  answers: Answers
  colorMode: 'light' | 'dark' | undefined
}) => {
  const firebaseGlobals = useContext(firebaseContext)
  const [dbData, setDbData] = useState<any>()
  const [counts, setCounts] = useState<any>()
  const [genderCompare, setGenderCompare] = useState('all')
  const [ageCompare, setAgeCompare] = useState('all')
  const [orientationCompare, setOrienationCompare] = useState('all')
  const [relationCompare, setRelationCompare] = useState('all')
  const startRef = useRef<HTMLDivElement>(null)
  const [userIsInGroup, setUserIsInGroup] = useState(false)
  const { width } = useWindowSize()
  const agegroups_lookup: { [key: string]: string } = {
    age_18_to_29: 'age_18_to_29',
    age_30_to_39: 'age_30_to_49',
    age_40_to_49: 'age_30_to_49',
    age_50_to_59: 'age_50_plus',
    age_60_to_69: 'age_50_plus',
    age_70_plus: 'age_50_plus',
  }

  const orientation_groups: { [key: string]: string } = {
    heterosexual: 'heterosexual',
    bisexual: 'other',
    homosexual: 'homosexual',
    other: 'other',
  }

  const gender_groups: { [key: string]: string } = {
    male: 'male',
    female: 'female',
    intersexual: 'other',
    other: 'other',
  }

  const u_gender = gender_groups[answers.gender]
  const u_age = agegroups_lookup[answers.age]
  const u_orientation = orientation_groups[answers.sexual_orientation]

  const u_relation =
    answers.relationship_status === 'single'
      ? 'single'
      : +answers.relationship_duration < 1
      ? 'relation_0_to_1'
      : +answers.relationship_duration < 6
      ? 'relation_1_to_5'
      : 'relation_5_plus'

  const lookup: { [key: string]: string } = {
    all: 'all',
    gender: u_gender,
    age: u_age,
    orientation: u_orientation,
    relation: u_relation,
  }

  useEffect(() => {
    setUserIsInGroup(
      userInGroup(
        answers,
        genderCompare,
        ageCompare,
        orientationCompare,
        relationCompare
      )
    )
    readFireBaseAnswers()
  }, [genderCompare, ageCompare, orientationCompare, relationCompare])

  function readFireBaseAnswers() {
    get(ref(firebaseGlobals.db, 'data/counts')).then((snapshot) => {
      setCounts(snapshot.val())
    })
    // onValue(firebaseGlobals.data, (snapshot) => {
    get(
      ref(
        firebaseGlobals.db,
        'data/' +
          genderCompare +
          '/' +
          ageCompare +
          '/' +
          orientationCompare +
          '/' +
          relationCompare
      )
    ).then((snapshot) => {
      // read only once
      if (snapshot.exists()) {
        const dbData = snapshot.val()
        if (
          (lookup.gender === genderCompare || genderCompare === 'all') &&
          (lookup.age === ageCompare || ageCompare === 'all') &&
          (lookup.orientation === orientationCompare ||
            orientationCompare === 'all') &&
          (lookup.relation === relationCompare || relationCompare === 'all')
        ) {
          mergeUserIntoDBData(dbData, answers)
        }

        setDbData(dbData)
      }
    })
    // onValue(firebaseGlobals.data, (snapshot) => {

    //     if (snapshot.exists()) {

    //     const dbData = snapshot.val()[lookup.gender][lookup.age][lookup.orientation][
    //       lookup.relation
    //     ]
    //
    //     if (
    //       (lookup.gender === genderCompare || genderCompare === 'all') &&
    //       (lookup.age === ageCompare || ageCompare === 'all') &&
    //       (lookup.orientation === orientationCompare ||
    //         orientationCompare === 'all') &&
    //       (lookup.relation === relationCompare || relationCompare === 'all')
    //     ) {    mergeUserIntoDBData(dbData, answers)

    //     }

    //     setDbData(
    //       dbData
    //     )
    //   }
    // })
  }
  const props_to_omit = ['send', 'group_agree']
  function mergeUserIntoDBData(dbData: any, user: any) {
    Object.entries(user)
      .filter((f) => !props_to_omit.includes(f[0] + ''))
      .map(([key, value]: any) => {
        if (!dbData[key][value]) dbData[key][value] = 0
        return dbData[key][value]++
      })
  }

  const genderselection = [
    { key: 'all', label: _t('all genders') },
    { key: 'male', label: _t('male') },
    { key: 'female', label: _t('female') },
    { key: 'other', label: _t('diverse') },
  ]
  const agegroups = [
    { key: 'all', label: _t('all ages') },
    { key: 'age_18_to_29', label: '18 – 29' },
    { key: 'age_30_to_49', label: '30 – 49' },
    { key: 'age_50_plus', label: '50+' },
  ]
  const orientationgroups = [
    { key: 'all', label: _t('all orientations') },
    { key: 'heterosexual', label: _t('hetero') },
    { key: 'homosexual', label: _t('homo') },
    { key: 'other', label: _t('other') },
  ]
  const relationgroups = [
    { key: 'all', label: _t('all relation duration') },
    { key: 'single', label: _t('single') },
    { key: 'relation_0_to_1', label: _t('less than a year') },
    { key: 'relation_1_to_5', label: _t('one to five years') },
    { key: 'relation_5_plus', label: _t('more than five years') },
  ]

  var Questions = getQuestionData(lang)

  const isMobile = width < 712
  const isDark = colorMode === 'dark'

  function handleGenderChange(e: string) {
    setGenderCompare(e)
  }

  function handleAgeChange(e: string) {
    setAgeCompare(e)
  }
  function handleOrientationChange(e: string) {
    setOrienationCompare(e)
  }
  function handleRelationChange(e: string) {
    setRelationCompare(e)
  }
  useEffect(() => {
    if (!startRef.current) return
    scrollIntoView(startRef.current as HTMLElement)
  }, [])

  const AgeLabels: { [key: string]: string } = {
    all: '',
    age_18_to_29: _t('18 to 29'),
    age_30_to_49: _t('30 to 49'),
    age_50_plus: _t('over 50'),
  }

  if (!dbData)
    return (
      <>
        <Loader lang={lang} />
      </>
    )

  var participants = 0
  if (
    counts &&
    counts[genderCompare] &&
    counts[genderCompare][ageCompare] &&
    counts[genderCompare][ageCompare][orientationCompare] &&
    counts[genderCompare][ageCompare][orientationCompare][relationCompare]
  ) {
    participants =
      counts[genderCompare][ageCompare][orientationCompare][relationCompare]
        .total
  }
  var allParticipants = counts.all.all.all.all.total
  return (
    <>
      <SelectionContainer ref={startRef}>
        <SideImage
          src={require('../../images/top_1' + (isDark ? '_dm' : '') + '.png')}
          style={{
            left: '50%',
            transform: 'translateX(-50%)',
            top: 0,
            opacity: 1,
            width: isMobile ? '1200px' : '100%',
            minWidth: '100%',
          }}
        />
        <SideImage
          src={require('../../images/bottom_1' +
            (isDark ? '_dm' : '') +
            '.png')}
          style={{
            left: '50%',
            transform: 'translateX(-50%)',
            bottom: 0,
            opacity: 1,
            width: isMobile ? '700px' : '100%',
            maxWidth: isMobile ? '700px' : 'calc(100% + 56px)',
            minWidth: isMobile ? '700px' : '100%',
          }}
        />

        <CompareSelect>
          <ButtonRow>
            <SendInfo>
              {_t('thanks for participating')}
              {/* <small>{_t('do again')}</small>
               */}
              <br />
              <ResetButton lang={lang} />
            </SendInfo>
          </ButtonRow>

          <CompareSelectTitle>
            {_t('choose group to compare')}
          </CompareSelectTitle>

          <Selects>
            {dbData && (
              <>
                <SelectContainer>
                  <SelectLabel>{_t('sex')}</SelectLabel>
                  <Select onChange={(e) => handleGenderChange(e.target.value)}>
                    {genderselection
                      .filter(
                        (f) =>
                          !!counts[f.key] &&
                          !!counts[f.key].all &&
                          !!counts[f.key].all.all &&
                          !!counts[f.key].all.all.all &&
                          counts[f.key].all.all.all.total > 0
                      )
                      .map((f) => (
                        <option
                          value={f.key}
                          selected={genderCompare === f.key}
                        >
                          {f.label}
                        </option>
                      ))}
                  </Select>
                </SelectContainer>
                <SelectContainer>
                  {' '}
                  <SelectLabel>{_t('age')}</SelectLabel>
                  <Select
                    onChange={(e) => {
                      handleAgeChange(e.target.value)
                    }}
                  >
                    {agegroups
                      .filter(
                        (f) =>
                          counts[genderCompare][f.key] &&
                          counts[genderCompare][f.key].all &&
                          counts[genderCompare][f.key].all.all &&
                          counts[genderCompare][f.key].all.all.total > 0
                      )
                      .map((f) => (
                        <option value={f.key} selected={ageCompare === f.key}>
                          {f.label}
                        </option>
                      ))}
                  </Select>
                </SelectContainer>
                <SelectContainer>
                  <SelectLabel>{_t('orientation')}</SelectLabel>
                  <Select
                    onChange={(e) => {
                      handleOrientationChange(e.target.value)
                    }}
                  >
                    {orientationgroups
                      .filter(
                        (f) =>
                          counts[genderCompare][ageCompare][f.key] &&
                          counts[genderCompare][ageCompare][f.key].all &&
                          counts[genderCompare][ageCompare][f.key].all.total > 0
                      )
                      .map((f) => (
                        <option
                          value={f.key}
                          selected={orientationCompare === f.key}
                        >
                          {f.label}
                        </option>
                      ))}
                  </Select>
                </SelectContainer>
                <SelectContainer>
                  <SelectLabel>{_t('status')}</SelectLabel>
                  <Select
                    onChange={(e) => {
                      handleRelationChange(e.target.value)
                    }}
                  >
                    {relationgroups
                      .filter(
                        (f) =>
                          counts[genderCompare][ageCompare][orientationCompare][
                            f.key
                          ] &&
                          counts[genderCompare][ageCompare][orientationCompare][
                            f.key
                          ].total > 0
                      )
                      .map((f) => (
                        <option
                          value={f.key}
                          selected={relationCompare === f.key}
                        >
                          {f.label}
                        </option>
                      ))}
                  </Select>
                </SelectContainer>
              </>
            )}
          </Selects>

          <Participants>
            {lang === 'de' && (
              <>
                {new TextBuilder()
                  .addText(
                    'Insgesamt haben ' +
                      tb_form(
                        allParticipants,
                        'eine Person',
                        'Personen',
                        true
                      ) +
                      ' an der Umfrage teilgenommen. '
                  )

                  .get()}
                <b>
                  {new TextBuilder()

                    .addText('Die von Ihnen ausgewählte Gruppe umfasst ')
                    .byProperty(genderCompare, {
                      all: tb_form(
                        participants,
                        'eine Person',
                        'Personen',
                        true
                      ),
                      male: tb_form(participants, 'einen Mann', 'Männer', true),
                      female: tb_form(
                        participants,
                        'eine Frau',
                        'Frauen',
                        true
                      ),
                      intersexual: tb_form(
                        participants,
                        'eine intersexuelle Person',
                        'intersexuelle Personen',
                        true
                      ),
                      other: tb_form(
                        participants,
                        'eine Person mit anderen Geschlecht',
                        'Personen mit anderen Geschlecht',
                        true
                      ),
                    })
                    .addText(' ')
                    .byProperty(ageCompare, AgeLabels)
                    .addText('.')
                    .get()}
                </b>
              </>
            )}
            {lang === 'fr' && (
              <>
                {new TextBuilder()
                  .addText(
                    'Au total, ' +
                      tb_form(
                        allParticipants,
                        'une personne',
                        'personnes',
                        true
                      ) +
                      " ont participé à l'enquête. "
                  )
                  .get()}

                <b>
                  {new TextBuilder()
                    .addText('Le groupe que vous avez sélectionné comprend ')
                    .byProperty(genderCompare, {
                      all: tb_form(
                        participants,
                        'une personne',
                        'personnes',
                        true
                      ),
                      male: tb_form(participants, 'un homme', 'hommes', true),
                      female: tb_form(
                        participants,
                        'une femme',
                        'femmes',
                        true
                      ),
                      intersexual: tb_form(
                        participants,
                        'une personne intersexuelle',
                        'personnes intersexuelles',
                        true
                      ),
                      other: tb_form(
                        participants,
                        "une personne d'un autre sexe",
                        "personnes d'un autre sexe",
                        true
                      ),
                    })
                    .addText(' ')
                    .byProperty(ageCompare, AgeLabels)
                    .addText('.')
                    .get()}
                </b>
              </>
            )}
          </Participants>
        </CompareSelect>
      </SelectionContainer>
      {participants < 1 && (
        <>
          <EvaluationPreview>
            {lang === 'de'
              ? 'Die Gruppe die Sie ausgewählt haben, umfasst leider noch keine Teilnehmer. Bitte wählen Sie eine andere Gruppe aus.'
              : 'Le groupe que vous avez sélectionné ne comprend malheureusement aucun participant. Veuillez sélectionner un autre groupe.'}
          </EvaluationPreview>
        </>
      )}
      {participants > 0 && (
        <>
          {' '}
          <EvaluationContainer>
            <CategoryTitle>
              <img src={require('../../images/icons/icons_satisfaction.png')} />
              {_t('satisfaction')}
            </CategoryTitle>
            <CategoryText>
              {lang === 'fr'
                ? 'Ces questions visent à évaluer la satisfaction globale que vous procure votre vie sexuelle.'
                : 'Diese Fragen zielen auf die grundsätzliche Zufriedenheit mit dem Sexleben.'}
            </CategoryText>
            {dbData && (
              <GenderSVGColumnChart
                userIsInGroup={userIsInGroup}
                domain={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                labels={[_t('unsatisfied'), _t('satisfied')]}
                title={Questions.satisfaction.question as string}
                data={dbData.satisfaction}
                user={answers.satisfaction}
                unit=''
              />
            )}
            {dbData && (
              <GenderBarChart
                userIsInGroup={userIsInGroup}
                title={Questions.sex_frequency.question as string}
                question={Questions.sex_frequency}
                data={dbData.sex_frequency}
                user={answers.sex_frequency}
                sort={[
                  'never_ever',
                  'never',
                  'less_than_once_per_month',
                  'one_to_two_times_month',
                  'three_to_four_times_month',
                  'two_to_three_times_week',
                  'four_to_five_times_week',
                  'six_to_seven_times_week',
                  'more_than_seven_times_week',
                ]}
                color='#4eff00'
              />
            )}
            {dbData && (
              <GenderBarChart
                userIsInGroup={userIsInGroup}
                title={Questions.sex_frequency_desired.question as string}
                question={Questions.sex_frequency_desired}
                data={dbData.sex_frequency_desired}
                user={answers.sex_frequency_desired}
                sort={[
                  'no_answer',
                  'much_less',
                  'less',
                  'same',
                  'more',
                  'much_more',
                ]}
                color='#4eff00'
              />
            )}
          </EvaluationContainer>
          <EvaluationContainer style={{ backgroundColor: 'var(--section-bg)' }}>
            <SideImage
              src={require('../../images/bottom_3' +
                (isDark ? '_dm' : '') +
                '.png')}
              style={{
                left: '50%',
                transform: 'translateX(-50%)',
                top: 0,
                opacity: 1,
                width: isMobile ? '1200px' : '100%',
                minWidth: '100%',
              }}
            />

            <CategoryTitle>
              <img src={require('../../images/icons/icons_orgasm.png')} />
              {_t('orgasm')}
            </CategoryTitle>
            <CategoryText>
              {lang === 'fr'
                ? "Les questions suivantes abordent les thèmes du plaisir, de la masturbation et de l'orgasme."
                : 'Folgende Fragen behandeln die Themenbereiche sexuelles Vergnügen, Masturbation und Orgasmen.'}
            </CategoryText>
            {dbData && (
              <GenderSVGColumnChart
                userIsInGroup={userIsInGroup}
                inverted
                domain={[
                  0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75,
                  80, 85, 90, 95, 100,
                ]}
                labels={[_t('never'), _t('always')]}
                title={Questions.orgasm_frequency_sex.question as string}
                data={dbData.orgasm_frequency_sex}
                user={answers.orgasm_frequency_sex}
                unit='%'
              />
            )}
            {dbData && (
              <GenderBarChart
                userIsInGroup={userIsInGroup}
                inverted
                title={Questions.orgasm_frequency_desired.question as string}
                question={Questions.orgasm_frequency_desired}
                data={dbData.orgasm_frequency_desired}
                user={answers.orgasm_frequency_desired}
                // icon='orgasm'
                sort={[
                  'no_answer',
                  'much_less',
                  'less',
                  'same',
                  'more',
                  'much_more',
                ]}
                color='#00f0ff'
              />
            )}

            {dbData && (
              <GenderBarChart
                userIsInGroup={userIsInGroup}
                inverted
                title={Questions.masturbation_frequency.question as string}
                question={Questions.masturbation_frequency}
                data={dbData.masturbation_frequency}
                user={answers.masturbation_frequency}
                sort={[
                  'never_ever',
                  'never',
                  'less_than_once_per_month',
                  'one_to_two_times_month',
                  'three_to_four_times_month',
                  'two_to_three_times_week',
                  'four_to_five_times_week',
                  'six_to_seven_times_week',
                  'more_than_seven_times_week',
                ]}
                color='#00f0ff'
              />
            )}
            {dbData && (
              <GenderSVGColumnChart
                userIsInGroup={userIsInGroup}
                inverted
                domain={[
                  0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75,
                  80, 85, 90, 95, 100,
                ]}
                labels={[_t('never'), _t('always')]}
                title={
                  Questions.orgasm_frequency_masturbation.question as string
                }
                data={dbData.orgasm_frequency_masturbation}
                user={answers.orgasm_frequency_masturbation}
                unit={'%'}
              />
            )}
          </EvaluationContainer>
          <EvaluationContainer style={{ paddingTop: '30px' }}>
            <SideImage
              src={require('../../images/top_2' +
                (isDark ? '_dm' : '') +
                '.png')}
              style={{
                left: '50%',
                transform: 'translateX(-50%)',
                top: 0,
                opacity: 1,
                width: isMobile ? '1200px' : '100%',
                minWidth: '100%',
              }}
            />
            <CategoryTitle>
              <img src={require('../../images/icons/icons_selfimage.png')} />
              {_t('self image')}
            </CategoryTitle>
            <CategoryText>
              {lang === 'fr'
                ? "La perception de soi en tant qu'être sexuel est un enjeu majeur dans la société contemporaine, mais elle demeure peu étudiée. Les questions suivantes portent sur les fonctions sexuelles et la satisfaction que nous procure notre corps."
                : 'Das sexuelle Selbstbild ist gesellschaftlich hochaktuell, jedoch wenig erforscht. Folgende Fragen drehen sich um sexuelle Funktionen und die Zufriedenheit des eigenen Körpers.'}
            </CategoryText>
            <FullWidth>
              <HalfCol className='halfcol'>
                {dbData && (
                  <GenderSVGColumnChart
                    userIsInGroup={userIsInGroup}
                    domain={[0, 1, 2, 3, 4, 5]}
                    labels={[
                      _t('does not apply at all'),
                      _t('does fully apply'),
                    ]}
                    title={Questions.genital_look.question as string}
                    data={dbData.genital_look}
                    user={answers.genital_look}
                  />
                )}
              </HalfCol>
              <HalfCol className='halfcol'>
                {dbData && (
                  <GenderSVGColumnChart
                    userIsInGroup={userIsInGroup}
                    domain={[0, 1, 2, 3, 4, 5]}
                    labels={[
                      _t('does not apply at all'),
                      _t('does fully apply'),
                    ]}
                    title={Questions.genital_function.question as string}
                    data={dbData.genital_function}
                    user={answers.genital_function}
                  />
                )}
              </HalfCol>
            </FullWidth>

            {dbData && (
              <GenderSVGColumnChart
                userIsInGroup={userIsInGroup}
                domain={[0, 1, 2, 3, 4, 5]}
                labels={[_t('does not apply at all'), _t('does fully apply')]}
                title={Questions.realize_sexual_demands.question as string}
                data={dbData.realize_sexual_demands}
                user={answers.realize_sexual_demands}
              />
            )}
            {dbData && (
              <GenderSVGColumnChart
                userIsInGroup={userIsInGroup}
                domain={[0, 1, 2, 3, 4, 5]}
                labels={[_t('does not apply at all'), _t('does fully apply')]}
                title={Questions.communicate_needed_mood.question as string}
                data={dbData.communicate_needed_mood}
                user={answers.communicate_needed_mood}
              />
            )}
            {dbData && (
              <GenderSVGColumnChart
                userIsInGroup={userIsInGroup}
                domain={[0, 1, 2, 3, 4, 5]}
                labels={[_t('do not agree at all'), _t('fully agree')]}
                title={Questions.right_to_orgasm.question as string}
                data={dbData.right_to_orgasm}
                user={answers.right_to_orgasm}
              />
            )}
            <EvaluationPreview>
              {lang === 'fr' ? (
                <>
                  Cette première évaluation des données est terminée. Nous vous
                  remercions encore une fois de votre participation. La semaine
                  prochaine, une analyse plus précise des résultats de l'enquête
                  sera publiée sur nos plateformes, avec les commentaires de
                  Stefanie Gonin-Spahni, sexologue de l'Institut de psychologie
                  de l'Université de Berne.
                </>
              ) : (
                <>
                  Das wars mit der ersten Auswertung der Daten. Vielen Dank
                  nochmals für Ihre Teilnahme. Nächste Woche folgt auf unseren
                  Kanälen eine tiefergehende Analyse der Umfrageergebnisse mit
                  Einschätzungen der Sexologin Stefanie Gonin-Spahni vom
                  Institut für Psychologie der Universität Bern.
                </>
              )}
            </EvaluationPreview>
          </EvaluationContainer>
        </>
      )}
    </>
  )
}
const EvaluationPreview = styled.div`
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  max-width: 668px;
  margin-top: 60px;
  margin-bottom: 60px;
  box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.4);
  box-shadow: 0px 10px 15px rgba(167, 87, 163, 0.2),
    0px 30px 80px rgba(0, 0, 0, 0.2);
  background-color: var(--purple-main);
  border-radius: 10px;
  padding: 30px;
  line-height: 1.4em;
  color: #fff;
  @media screen and (max-width: 711px) {
    max-width: calc(100vw - 100px);
  }
`

export default Evaluation

const CategoryText = styled.div`
  font-family: var(--font-serif);
  margin-top: 60px;
  max-width: 668px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 30px;
  @media screen and (max-width: 711px) {
    margin-left: 20px;
    max-width: calc(100vw - 40px);
  }
`

const HalfCol = styled.div`
  flex: 0 0 calc(50% - 60px);
  padding-right: 30px;
  display: flex;
  align-items: flex-end;
  @media screen and (max-width: 712px) {
    flex: unset;
    padding-right: 0px;
  }
`
const CategoryTitle = styled.div`
  max-width: 668px;
  margin-left: auto;
  margin-right: auto;
  font-size: 30px;
  font-weight: 200;
  color: var(--purple-main);
  text-align: center;
  letter-spacing: 3px;
  text-transform: uppercase;
  z-index: 100;
  position: relative;
  /* margin-top: 60px; */
  padding-top: 40px;
  @media screen and (max-width: 711px) {
    margin-bottom: 40px;
    margin-left: 0;
    max-width: 100vw;
  }
  img {
    margin-bottom: 5px;
    max-width: 100%;
    @media screen and (max-width: 711px) {
      max-width: 100vw;
    }
  }
`

const FullWidth = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: center;
  max-width: 1018px;
  margin-left: auto;
  margin-right: auto;
`

const SideImage = styled.img`
  position: absolute;
  z-index: 1;
  opacity: 0.5;
  max-width: calc(100% + 28px);
`

const SendInfo = styled.div`
  width: 100%;
  /* box-shadow: 0px 10px 20px 0px rgba(167, 87, 163, 0.4); */
  box-shadow: 0px 10px 15px rgba(167, 87, 163, 0.2),
    0px 30px 80px rgba(0, 0, 0, 0.2);
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0px;
  color: var(--input-active-color);
  color: #fff;
  background-color: #fff;
  padding: 40px 50px;

  /* padding-bottom: 0; */
  font-weight: 700;
  font-size: 26px;
  line-height: 1.3em;
  background-color: var(--input-active-color);
  border-radius: 10px;
  @media screen and (max-width: 1023px) {
    font-size: 18px;
    padding: 20px 10px;
  }
  span {
    margin-bottom: 15px;
    display: inline-block;
    width: 100%;
    margin-bottom: 30px;
  }
`
const ButtonRow = styled.div`
  text-align: center;
  position: relative;
  z-index: 40;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 40px;
  margin-top: -120px;
  @media screen and (max-width: 712px) {
    margin-top: 0px;
  }
  small {
    font-size: 15px;
    display: inline-block;
    width: 100%;
    font-weight: 300;
    line-height: 1.4em;
    @media screen and (max-width: 712px) {
      font-size: 12px;
    }
  }
`
const EvaluationContainer = styled.div`
  padding-bottom: 90px;
  margin-top: 0;
  position: relative;
  margin-left: -28px;
  width: calc(100% + 56px);
  @media screen and (max-width: 711px) {
    padding-left: 28px;
    padding: 0;
    width: calc(100% - 0px);
    overflow-x: hidden;
    margin-left: unset;
  }
`
const SelectionContainer = styled.div`
  background-color: var(--section-bg);
  padding-bottom: 300px;
  margin-top: 0;
  position: relative;
  margin-left: -28px;
  margin-right: -28px;
  text-align: center;

  @media screen and (max-width: 1679px) {
    padding-bottom: 220px;
    overflow-x: hidden;
  }

  @media screen and (max-width: 712px) {
    margin-left: unset;
    margin-right: unset;
    width: calc(100% + 40px);
    max-width: calc(100% - 0px);
    /* padding-left: 20px;
    padding-right: 20px; */
    padding-bottom: 150px;
  }
`
const Participants = styled.div`
  text-align: center;
  margin-top: 30px;
  font-size: 15px;
  line-height: 1.5em;
  border: 1px solid var(--gray-4);
  padding: 30px;
  margin-top: 60px;
`
const CompareSelect = styled.div`
  max-width: 668px;
  margin-left: auto;
  margin-right: auto;
  padding: 30px;
  padding-top: 100px;

  border-radius: 15px;
  margin-top: 60px;
  @media screen and (max-width: 711px) {
    max-width: calc(100vw - 40px);
    margin-left: unset;
    margin-right: unset;
    margin-top: 0px;
    border-radius: 0px;
    padding: 20px;
  }
`
const CompareSelectTitle = styled.div`
  z-index: 1000;
  position: relative;
  text-align: center;
  line-height: 1.4em;
  margin-top: 20px;
  margin-bottom: 0px;
  font-size: 26px;
  letter-spacing: 0.2px;
  font-family: var(--font-serif);
  font-family: 'Suez One', serif;
  font-weight: 700;
  margin-bottom: 30px;
  select,
  .select:after {
    grid-area: select;
  }
  @media screen and (max-width: 711px) {
    font-size: 20px;
    margin-bottom: 15px;
  }
`
const Selects = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  @media screen and (max-width: 711px) {
    gap: 20px;
  }
`
const SelectContainer = styled.div`
  width: calc(50% - 15px);
  @media screen and (max-width: 711px) {
    width: 100%;
  }
`
const Select = styled.select`
  appearance: none;
  -webkit-appearance: none;
  position: relative;
  color: var(--text-color);
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  border: 0;
  border-radius: 4px;
  padding: 15px 20px;
  font-size: 18px;
  cursor: pointer;
  font-size: 15px;
  line-height: 1.1;
  background-color: var(--site-background);

  background: url(${require('../../images/caret_down.png')}) no-repeat right
      0.8em center / 1.4em,
    var(--site-background);
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0.4px 0.5px rgba(0, 0, 0, 0.02),
    0px 1px 1.2px rgba(0, 0, 0, 0.028), 0px 1.9px 2.3px rgba(0, 0, 0, 0.035),
    0px 3.4px 4px rgba(0, 0, 0, 0.042), 0px 6.3px 7.5px rgba(0, 0, 0, 0.05),
    0px 15px 18px rgba(0, 0, 0, 0.07);
`
const SelectLabel = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 15px;
  font-weight: 700;
  line-height: 3.2em;
`
